export default __webpack_public_path__ + "locales/es/Errors.json?hash=8bb27f8f6504a4c33277f3f8ba08f1c1";